export default __webpack_public_path__ + "static/media/ic_wbase_24.b37129e7.svg";